var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.207 13.0622L1.92215 71.2419C1.03425 72.1282 1.03425 73.5652 1.92215 74.4515C2.81005 75.3378 4.24964 75.3378 5.13754 74.4515L63.4224 16.2718C64.3103 15.3855 64.3103 13.9485 63.4224 13.0622C62.5345 12.1759 61.0949 12.1759 60.207 13.0622Z",
    fill: "#A97417"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4141 34.823L38.8712 19.705L58.6119 0L59.069 14.2054L38.4141 34.823Z",
    fill: "#FDC000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.626 38.0288L56.7713 37.5725L76.5 17.8674L62.2809 17.4111L41.626 38.0288Z",
    fill: "#FDC000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalArrow);
export default __webpack_public_path__ + "static/media/GoalArrow.d86175bf59dabd0c5be12bc0e4f1a9b8.svg";
export { ForwardRef as ReactComponent };